"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZShowcase = void 0;
const react_1 = __importDefault(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const styled_components_1 = __importDefault(require("styled-components"));
const Mask = (props) => {
    const MaskDiv = styled_components_1.default.div `
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: black;
      opacity: 80%;
      z-index: 10003;
   `;
    return react_1.default.createElement(MaskDiv, null);
};
exports.ZShowcase = (props) => {
    const Grid = styled_components_1.default.div `
      position: fixed;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: transparent;
      z-index: 10004;
      display: grid;
   `;
    const Item = styled_components_1.default.div `
      background-color: white;
      align-self: center;
      justify-self: center;
      padding: 10px;
   `;
    return react_dom_1.default.createPortal(react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Mask, null),
        props.center === false ? (props.children) : (react_1.default.createElement(Grid, null,
            react_1.default.createElement(Item, null, props.children)))), document.body);
};
//# sourceMappingURL=ZShowcase.js.map